import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerSmpl } from '@src/store/slice/appSettingsSlice';

const GoogleAndSmplComponent = () => {
  const smplRef = useRef();
  const [smplHTML, setSmplHTML] = useState('');
  const { customerSmpl } = useSelector((state) => state.appSettings);
  const { selectedCustomer } = useSelector((state) => state.customer);
  const { currentUser } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentUser?.id && selectedCustomer?.customerId && !customerSmpl?.customerId) {
      dispatch(getCustomerSmpl());
    }
  }, [selectedCustomer, currentUser]);

  useEffect(() => {
    if (!smplRef.current) return;
    if (!selectedCustomer?.customerId) return;
    setSmplHTML(`
      CUSTOMER_CODE: ${selectedCustomer?.customerId || ''},
      NUMBEROFEMPLOYEES: ${customerSmpl.numberOFEmployees || ''},
      NUMBEROFCAR: ${customerSmpl.numberOfCar || ''},
      CUSTOMERROLE: ${customerSmpl.customerRole || ''},
      VOU_TR: ${customerSmpl.vou_tr || ''},
      VOU_TC: ${customerSmpl.vou_tc || ''},
      VOU_CAR: ${customerSmpl.vou_car || ''},
      VOU_TR_LAST_ORDER_DATE: ${customerSmpl.vou_tr_last_order_date || ''},
      TR_PAYMENT_TYPE: ${customerSmpl.tr_payment_type || ''},
      TCAR_PAYMENT_TYPE: ${customerSmpl.tcar_payment_type || ''},
      TC_PAYMENT_TYPE: ${customerSmpl.tr_payment_type || ''},
      IS_BLOCKED_CUSTOMER: ${customerSmpl.is_blocked_customer || ''},
      BLOCKED_DATE: ${customerSmpl.blocked_date || ''}
      USERNAME: ${currentUser.userName || ''},
      `);
  }, [customerSmpl, currentUser]);

  useEffect(() => {
    if (!smplHTML) return;
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const scripts = document.getElementsByTagName('script')[0];
    const newScript = document.createElement('script');
    newScript.async = true;
    newScript.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-T439954';
    scripts.parentNode.insertBefore(newScript, scripts);
  }, [smplHTML]);

  return (
    <>
      <div style={{ display: 'none' }} id="smpl" ref={smplRef}>
        {smplHTML}
      </div>
    </>
  );
};
export default GoogleAndSmplComponent;
